// Where a station lands after setting their password (RCS-43).
//
// Auth0 sends them here from the password ticket, so this page exists mainly so
// that the last step of accepting an invitation does not end on a blank screen.
// It deliberately promises nothing it cannot do: the self-service setup screens
// for stream, branding and player are still to be built, and until they are,
// Creator Rabbit finishes that part with the station.
//
// There is no token here and nothing to load. The address in the URL is only
// shown back to them, never trusted for anything.

import React from 'react';
import { useParams } from 'react-router-dom';
import useTitle from './useTitle';
import './onboarding.css';

export default function SetupPage() {
  useTitle('Your station — Creator Rabbit');
  const { tenantId } = useParams();

  return (
    <div className="ob-page">
      <div className="ob-bar">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="14" r="4" />
          <path d="M4 14a8 8 0 0 1 8-8" />
          <path d="M20 8.5 8.5 13" />
        </svg>
        <strong>Creator Rabbit</strong>
      </div>
      <div className="ob-wrap">
        <div className="ob-center">
          <div className="ob-tick" aria-hidden="true">&#10003;</div>
          <h1>Your sign-in is ready</h1>
          <p>
            Your password is set, and your station address is reserved for you.
          </p>
          {tenantId && (
            <dl className="ob-kv">
              <div>
                <dt>Station address</dt>
                <dd><code>{tenantId}</code></dd>
              </div>
            </dl>
          )}
          <div className="ob-note info">
            <span>
              <strong>What happens next.</strong> Creator Rabbit sets up your stream,
              branding and player with you, and your station goes live once that is done.
              Reply to your invitation email whenever you are ready to start.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
